import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    infoWrap: {
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "1rem 1fr",
        background: tailwindPalette.sky[50],
        borderRadius: "0.5rem",
        gap: "0.625rem",
        padding: "0.75rem",
        color: tailwindPalette.sky[700],
        width: "100%",
        "&> svg": {
            display: "block",
            alignSelf: "start",
            marginTop: "0.1rem",
        },
    },
}))

type InfoBoxProps = { description: string }

export const InfoBox = ({ description }: InfoBoxProps) => {
    const { classes } = useStyles()

    return (
        <Box className={classes.infoWrap}>
            <FontAwesomeIcon icon={faCircleInfo} />
            <Typography variant="body2">{description}</Typography>
        </Box>
    )
}
